import { config } from "core/config/app";
import { capitalizeFirstLetter } from "core/utils/helper";


const NotFound = () => {
  //console.log(window.location);
  
  return (
    <main className="not-found-page">
      <div className="content">
        <h1 className="text-center">404</h1>
        <h2>This page could not be found.</h2>
        Please visit with link: {" "} 
        <a href={`${config.basename}`}>{`${window.location.host}${capitalizeFirstLetter(config.basename)}`}</a>
      </div>
    </main>
  )
}

export default NotFound;